import { render, staticRenderFns } from "./introduce.vue?vue&type=template&id=35b1887b"
import script from "./introduce.vue?vue&type=script&lang=js"
export * from "./introduce.vue?vue&type=script&lang=js"
import style0 from "./introduce.vue?vue&type=style&index=0&id=35b1887b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports